import { css } from '@emotion/react';
import { Button, color, spacing, typography } from '@uniquegood/realworld-studio-design';

import ConnectCard from '../components/ConnectCard';
import Countdown from '../components/Countdown';
import UserInfoCard from '../components/UserInfoCard';

interface NoChannelStateProps {
  email: string;
  nickname: string;
  remainingSeconds: number | null;
  onCreateChannel: () => void;
}

/**
 * success-no-channel state.
 *
 * exchange + 로그인 성공했지만, 보유 채널이 0개라 연결할 대상이 없다.
 * `/createApp?return=/connect/resume` 으로 이동하여 채널 생성 후 복귀한다.
 */
export default function NoChannelState({
  email,
  nickname,
  remainingSeconds,
  onCreateChannel
}: NoChannelStateProps) {
  return (
    <ConnectCard eyebrow="Realworld School" title="스쿨 계정 연결">
      <div css={styles.body} data-testid="connect-state-no-channel">
        <p css={styles.description}>
          연결할 채널이 없어요.
          <br />
          새 채널을 만들어 스쿨 계정과 연결하세요.
        </p>

        <UserInfoCard email={email} nickname={nickname} maskEmail />

        <div css={styles.footer}>
          <Countdown remainingSeconds={remainingSeconds} />
          <Button type="primary" size="medium" onClick={onCreateChannel} cssStyle={styles.button}>
            새 채널 만들기
          </Button>
        </div>
      </div>
    </ConnectCard>
  );
}

const styles = {
  body: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${spacing.common.medium};
  `,
  description: css`
    margin: 0;
    color: ${color.text_default};
    font-size: ${typography.size.s2};
    line-height: 1.5;
  `,
  footer: css`
    margin-top: auto;
    display: flex;
    flex-direction: column;
    gap: ${spacing.common.small};
  `,
  button: css`
    width: 100%;
    font-weight: ${typography.weight.medium};
  `
};
